// Scopes localStorage data (events, tasks) to the currently authenticated user
// so each account keeps its own isolated calendar/tasks on the device.
// Anonymous (pre-account) data uses the legacy un-prefixed keys and stays separate.

import { ignore } from "./log";

let activeUid = null;

export function setActiveUid(uid) {
  activeUid = uid || null;
  try {
    if (uid) {
      localStorage.setItem("chronicles.activeUid", uid);
      migrateLegacyEvents(uid);
    } else {
      localStorage.removeItem("chronicles.activeUid");
    }
  } catch {
    ignore();
  }
}

// One-time recovery: events written to the legacy un-scoped key
// ("chronicles.events.v1") — including any approved during the store-key
// mismatch bug and pre-namespacing data — are moved into the active user's
// scoped store IF that store is still empty, then the legacy key is cleared so
// this runs at most once. We never overwrite an account that already has events.
function migrateLegacyEvents(uid) {
  const LEGACY = "chronicles.events.v1";
  const scoped = `chronicles.u_${uid}.events.v1`;
  try {
    const legacyRaw = localStorage.getItem(LEGACY);
    if (!legacyRaw) return;
    const legacy = JSON.parse(legacyRaw);
    if (!Array.isArray(legacy) || legacy.length === 0) {
      localStorage.removeItem(LEGACY);
      return;
    }
    const scopedRaw = localStorage.getItem(scoped);
    const scopedArr = scopedRaw ? JSON.parse(scopedRaw) : [];
    if (Array.isArray(scopedArr) && scopedArr.length > 0) return;
    localStorage.setItem(scoped, JSON.stringify(legacy));
    localStorage.removeItem(LEGACY);
    window.dispatchEvent(new CustomEvent("chronicles:changed"));
  } catch {
    ignore();
  }
}

export function getActiveUid() {
  if (activeUid) return activeUid;
  try {
    return localStorage.getItem("chronicles.activeUid");
  } catch {
    return null;
  }
}

export function scopedKey(base) {
  const uid = getActiveUid();
  return uid ? `chronicles.u_${uid}.${base}` : `chronicles.${base}`;
}
